var Strings = {
  "de-DE": require("./values/de-DE.json"),
  "en-US": require("./values/en-US.json"),
  "es-ES": require("./values/es-ES.json"),
  "fr-CA": require("./values/fr-CA.json"),
  "fr-FR": require("./values/fr-FR.json"),
  "it-IT": require("./values/it-IT.json"),
  "ja-JP": require("./values/ja-JP.json"),
  "nl-NL": require("./values/nl-NL.json"),
  "pt-BR": require("./values/pt-BR.json")
};

module.exports = Strings;
